import application from 'application/application';

const controller = 'ForgotPasswordController';

/* eslint-disable no-unused-vars */

application

	.controller(controller, ['$scope', '$http', '$state', 'helper', 'API', ($scope, $http, $state, helper, API) => {

		$scope.showFeedback = false;

		$scope.resetPassword = email => {

			$('.busy-overlay').addClass('open');

			$http({
				...helper.http(API.forgotPassword, 'POST'),
				data: { email },
				status
			})

				/** @TODO: Alterar o redirecionamento quando solicionar o problema com `stateService.prototype.go`. */
				.then(() => $scope.showFeedback = true)

				.finally(() => $('.busy-overlay').removeClass('open'));

		};

		$scope.goTo = routePath => location.href = $state.get(routePath).url || '/';

	}]);

export default controller;
